import { ActionTypes } from '../constants/index';

export const getNotificationEcommerce = (payload: any) => ({
  type: ActionTypes.ECOMMERCE_NOTIFOCATION_REQUEST,
  payload,
});
